const finite = (value, fallback = 0) =>
  Number.isFinite(Number(value)) ? Number(value) : fallback;

export const clampOverlayPosition = ({
  x,
  y,
  width,
  height,
  viewportWidth,
  viewportHeight,
  margin = 12,
  topInset = 0,
  bottomInset = 0,
} = {}) => {
  const safeMargin = Math.max(0, finite(margin, 12));
  const safeWidth = Math.max(0, finite(width));
  const safeHeight = Math.max(0, finite(height));
  const viewportW = Math.max(0, finite(viewportWidth));
  const viewportH = Math.max(0, finite(viewportHeight));
  const minimumX = safeMargin;
  const minimumY = Math.max(safeMargin, finite(topInset) + safeMargin);
  const maximumX = Math.max(
    minimumX,
    viewportW - safeWidth - safeMargin
  );
  const maximumY = Math.max(
    minimumY,
    viewportH - safeHeight - Math.max(0, finite(bottomInset)) - safeMargin
  );

  return {
    x: Math.min(maximumX, Math.max(minimumX, finite(x, minimumX))),
    y: Math.min(maximumY, Math.max(minimumY, finite(y, minimumY))),
  };
};

